module.exports = __webpack_public_path__ + "static/media/logout_icon.37e6595e.svg";